import React from 'react';
import { EntityEditPage } from './EntityEditPage';

export const ComponentEditPage = () => {
  return <EntityEditPage />;
};
